module.exports = __webpack_public_path__ + "static/media/design-spark.4ea386e2.jpeg";